import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';
import { audiosAssets } from '../../../assets/audio';
import { ButtonHome } from '../../../components/common/ButtonHome';
import { ButtonPlay } from '../../../components/common/ButtonPlay';
import { HeaderRedPresentation } from '../../../components/common/HeaderRedPresentation';
import { DialogBarNew } from '../../../components/common/DialogBarNew';
import { PanelActivities } from '../../../components/common/PanelActivities';
import { BarStatusActivies } from '../../../components/common/BarStatusActivies';
import { ValidationResultModal } from '../../../components/common/ValidationResultModal';
import { useNavigate } from 'react-router-dom';
import { completeOneTask } from '../../../store/slices/menu/tunks';
import { tasksId } from '../../../types/activityTasks';
import { useGetActivitiesBySubTopic } from '../../../hooks/useGetActivitiesBySubTopic';
import { voicesTypeControl } from '../../../types/audioType';
import { ButtonReturn } from '../../../components/common/ButtonReturn';


const steps = {
	dialogInitial: 1,
	panelActivities: 2,
	dialogTwo: 3,
	dialogThree: 4,
	dialogFour: 5,
	dialogFive: 6,
	dialogSix: 7,
	dialogSeven: 8,
	dialogEight: 9,
	dialogNine: 10,
	dialogTen: 11,
	dialogEleven: 12,
	dialogTwelve: 13,
	dialogThirteen: 14,
	win: 15
};


const stepThree = {
	room_cold: steps.dialogSeven,
	select_product: steps.dialogEight,
	view_microware: steps.dialogNine,
	final_message: steps.dialogTwelve
};

const stepThreeAudio = {
	room_cold: {
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_2.sub2_act1_a06T3)
		}
	},
	select_product: {
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_2.sub2_act1_a07T3)
		}
	},
	view_microware: {
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_2.sub2_act1_a09T3)
		}
	},
	final_message: {
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_2.sub2_act1_a12T3)
		}
	},
}

export const Theme3SubtopicTwoActivityOne = () => {
	const navigator = useNavigate()
	const dispatch = useDispatch()
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema3.activities.subtema2], 1);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);

	useEffect(() => {
		if (loaded) {
			console.log("theme 3 sub 2 act 1");
			ObserverEmitter.emit(EVENTS.tema3.topic2.initScene, 1);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_2.sub2_act1_a01T3)
	})

	ObserverEmitter.on(EVENTS.tema3.topic2.actOne.finishMoveAnimation, (step = "") => {
		const stepSelect = stepThree[step]
		if (!stepSelect) {
			return
		}
		setUiToShow(stepSelect)

		const stepAudio = stepThreeAudio[step]
		stepAudio.action()

	})

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1, -2].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema3.topic2.initScene, 1);
						setUiToShow(1)
					}} />
				)}
			</>

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Actividad 1: Warmer" />
					<DialogBarNew
						dialog={`¡Es genial que continúes aquí! espero que estés aprendiendo mucho, ¡aún quiero compartir más contigo sobre nuestra Tienda!`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.panelActivities);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 2: Máquina Warmer y Koxka y Salchikoxka"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_2.sub2_act1_a02T3)
							ObserverEmitter.emit(EVENTS.characterAnimations.saludo);
							setUiToShow(steps.dialogTwo);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.dialogTwo && (
				<>
					<BarStatusActivies
						activities={tasksList}
					/>
					<DialogBarNew
						dialog={`Ahora te presento a nuestra sección Warmer. Aquí acuden nuestros clientes cuando quieren algún alimento caliente previamente preparado.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_2.sub2_act1_a03T3)
							ObserverEmitter.emit(EVENTS.tema3.topic2.actOne.moveAroundStation, "wall_clock")
							setUiToShow(steps.dialogThree);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogThree && (
				<>
					<DialogBarNew
						dialog={`A continuación te mostraré los puntos indispensables para su correcta exhibición.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_2.sub2_act1_a04T3)
							ObserverEmitter.emit(EVENTS.tema3.topic2.actOne.stepActivateInformation, "turn_on_machine")
							setUiToShow(steps.dialogFour);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFour && (
				<>
					<DialogBarNew
						dialog={`Deberás encender la máquina Warmer a las 7:00 a.m. todos los días. 
						Verifica que la temperatura sea de entre 60 a 65 grados.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_2.sub2_act1_a05T3)
							setUiToShow(steps.dialogSix);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSix && (
				<>
					<DialogBarNew
						dialog={`Ve al Cuarto Frío, utilizando el método PEPS y toma los productos a exhibir según la variedad faltante, que se muestra en pantalla.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic2.actOne.moveAroundStation, "room_cold")
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSeven && (
				<>
					<DialogBarNew
						dialog={`Selecciona el producto que no estaba exhibido en la máquina Warmer.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic2.actOne.stepActivateInformation, "select_product")
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogEight && (
				<>
					<DialogBarNew
						dialog={`¡Excelente trabajo! Recuerda tomar los productos que hacen falta en exhibición.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic2.actOne.moveAroundStation, "go_back_microwave")
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogNine && (
				<>
					<DialogBarNew
						dialog={`Retira y desecha las bolsas transparentes de los alimentos para calentarlos según las instrucciones de sus empaques.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_2.sub2_act1_a10T3)
							setUiToShow(steps.dialogTen);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogTen && (
				<>
					<DialogBarNew
						dialog={`Introduce en el microondas el producto que necesitas calentar para exhibir en la máquina Warmer.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_2.sub2_act1_a11T3)
							setUiToShow(steps.dialogEleven);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogEleven && (
				<>
					<DialogBarNew
						dialog={`Luego de calentar, acomoda los productos faltantes en sus respectivos compartimentos en la máquina Warmer.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic2.actOne.moveAroundStation, "wall_clock_final")
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogTwelve && (
				<>
					<DialogBarNew
						dialog={`El tiempo máximo de exhibición de cada producto es de 4 horas. Al retirar los productos caducados, llévalos a la caja de mermas y realiza la devolución a CEDIS. Mantén al menos 2 productos exhibidos por parrilla (4 en total).`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_2.sub2_act1_a13T3)
							ObserverEmitter.emit(EVENTS.tema3.topic2.actOne.stepActivateInformation, "visible_trapo")
							setUiToShow(steps.dialogThirteen);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogThirteen && (
				<>
					<DialogBarNew
						dialog={`Diariamente realiza la limpieza externa del equipo con sanitizante, papel secante y el trapo azul. Apaga el equipo a las 8:00 p.m.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic2.actOne.stepActivateInformation)
							setUiToShow(steps.win);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						dialogModal="La limpieza y el cuidado de los alimentos es clave dentro de toda nuestras áreas de comida."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 1,
									pointsWin: 0,
									subtema: tasksId.tema3.activities.subtema2
								})
							);
							navigator("/home3/tema3/subtema2/activityTwo");
						}}
					/>
				</>
			)}
		</>
	)
}
